import { BaseFormControlLabel } from '../../Form/BaseFormControlLabel/BaseFormControlLabel';
import css from './Radio.module.scss';
import { BaseRadio } from '../BaseRadio/BaseRadio';
import { RadioProps } from './Radio.types';

/**
 * The `Radio` button control for the `RadioGroup` control. This provides the radio buttons
 * for the radio group to use.
 *
 * @param label - {@link RadioProps.label label} description.
 * @param value - {@link RadioProps.value value} description.
 */
const Radio = ({
    label,
    value,
}: RadioProps) => {
    return (
        <BaseFormControlLabel
            classes={{
                root: css.radioButton,
            }}
            control={
                <BaseRadio
                    classes={{
                        root: css.radioIcon,
                        checked: css.checked,
                    }}
                    value={value}
                />
            }
            label={
                <span
                    role={'presentation'}
                    aria-label={'radio-label'}
                    className={css.label}
                >
                    {label}
                </span>
            }
            value={value}
        />
    );
};

export default Radio;